"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _FooterNavigation = _interopRequireDefault(require("./FooterNavigation"));

var _FooterLink = _interopRequireDefault(require("./FooterLink"));

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _color = _interopRequireDefault(require("../../constants/color"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Footer(_ref) {
  var children = _ref.children,
      _ref$pushCenter = _ref.pushCenter,
      pushCenter = _ref$pushCenter === void 0 ? true : _ref$pushCenter,
      transparent = _ref.transparent;
  var footerClasses = ['co-footer', [transparent ? null : _color.default.background.gray[100]]];
  return _react.default.createElement(_styler.default, {
    classNames: footerClasses,
    modifiers: {
      pushCenter: pushCenter
    }
  }, function (styles) {
    return _react.default.createElement("footer", {
      className: styles
    }, children);
  });
}

Footer.propTypes = {
  /** {---} Sequence of: @@<small>@@ (required, max: 1) and @@<Footer.Navigation>@@ (optional, max: 1) */
  children: _propTypes.any.isRequired,
  pushCenter: _propTypes.bool,
  transparent: _propTypes.bool
};
Footer.Navigation = _FooterNavigation.default;
Footer.Link = _FooterLink.default;
var _default = Footer;
exports.default = _default;
Footer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Footer",
  "props": {
    "pushCenter": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{---} Sequence of: @@<small>@@ (required, max: 1) and @@<Footer.Navigation>@@ (optional, max: 1)"
    },
    "transparent": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};